module.exports = "/images/external-link-alt-solid.svg?b9a22aa310a14e1970b416fbf7564d30";